import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'UGX') {
  return new Intl.NumberFormat('en-UG', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-UG', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatNumber(num) {
  return new Intl.NumberFormat('en-UG').format(num);
}

export const INCOME_SOURCES = [
  { value: 'school_fees', label: 'School Fees' },
  { value: 'school_fees_collection', label: 'School Fees Collection' },
  { value: 'donations', label: 'Donations' },
  { value: 'grants', label: 'Grants' },
  { value: 'chicken_sales', label: 'Chicken Sales' },
  { value: 'garden_produce', label: 'Garden Produce' },
  { value: 'masonry_sales', label: 'Masonry Sales' },
  { value: 'loan_interest', label: 'Loan Interest' },
  { value: 'fundraising', label: 'Fundraising' },
  { value: 'maize_sales', label: 'Maize Sales' },
];

export const EXPENSE_CATEGORIES = [
  { value: 'salaries', label: 'Salaries' },
  { value: 'school_supplies', label: 'School Supplies' },
  { value: 'farming_costs', label: 'Farming Costs' },
  { value: 'masonry_materials', label: 'Masonry Materials' },
  { value: 'transport', label: 'Transport' },
  { value: 'operational_costs', label: 'Operational Costs' },
  { value: 'maize_purchases', label: 'Maize Purchases' },
];

export const USER_ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'finance_officer', label: 'Finance Officer' },
  { value: 'school_head', label: 'School Head' },
  { value: 'project_manager', label: 'Project Manager' },
  { value: 'loan_officer', label: 'Loan Officer' },
  { value: 'staff', label: 'Staff / Teacher' },
  { value: 'board_member', label: 'Board Member' },
];

export const PROJECT_TYPES = [
  { value: 'chicken_farming', label: 'Chicken Farming' },
  { value: 'school_garden', label: 'School Garden' },
  { value: 'masonry', label: 'Masonry' },
  { value: 'women_development', label: 'Women for Development' },
];

export const TIME_PERIODS = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
];

export const LOAN_STATUS = [
  { value: 'active', label: 'Active', color: 'blue' },
  { value: 'repaid', label: 'Repaid', color: 'green' },
  { value: 'overdue', label: 'Overdue', color: 'red' },
];

export const ATTENDANCE_STATUS = [
  { value: 'present', label: 'Present' },
  { value: 'absent', label: 'Absent' },
  { value: 'late', label: 'Late' },
  { value: 'leave', label: 'On Leave' },
];
